import Cookies from 'js-cookie'

export const setCookie = (name, value) => {
  return Cookies.set(name, value)
}

export const getCookie = (name) => {
  return Cookies.get(name)
}

export const getSelectedCategory = () => {
  return Cookies.get('selectedCategory')
}
